import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AppNav from '../AppNav/AppNav';

export default function JobKindSettingsPage() {
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    let active = true;

    async function load() {
      try {
        const response = await fetch('/++api++/@job-kind-settings', {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) {
          throw new Error(`Job kind settings failed with status ${response.status}`);
        }
        const payload = await response.json();
        if (active) {
          setValue((payload.items || []).join('\n'));
        }
      } catch (loadError) {
        if (active) {
          setError(loadError.message);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      active = false;
    };
  }, []);

  async function onSave(event) {
    event.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      const items = value
        .split('\n')
        .map((item) => item.trim())
        .filter(Boolean);
      const response = await fetch('/++api++/@job-kind-settings', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) {
        throw new Error(await extractError(response));
      }
      const payload = await response.json();
      setValue((payload.items || []).join('\n'));
      setSuccess('Job kinds updated.');
    } catch (saveError) {
      setError(saveError.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <main className="patent-entry">
      <section className="patent-entry__shell">
        <AppNav currentPath="/jobs" />
        <header className="patent-entry__hero">
          <p className="patent-entry__eyebrow">Settings</p>
          <h1>Editable job kinds</h1>
          <p className="patent-entry__note">
            One item per line. Existing jobs keep their stored values even if you change this list.
          </p>
          <div className="patent-entry__actions patent-entry__actions--row">
            <Link className="patent-entry__ghost" to="/overview">
              Back to overview
            </Link>
          </div>
        </header>

        {loading ? <p className="patent-entry__note">Loading settings…</p> : null}

        {!loading ? (
          <form className="patent-entry__form" onSubmit={onSave}>
            <label className="patent-entry__field patent-entry__field--wide">
              <span className="patent-entry__label">Job kinds</span>
              <textarea
                className="patent-entry__textarea"
                rows="8"
                value={value}
                onChange={(event) => setValue(event.target.value)}
              />
            </label>
            {error ? <p className="patent-entry__error">{error}</p> : null}
            {success ? <p className="patent-entry__success">{success}</p> : null}
            <div className="patent-entry__actions">
              <button className="patent-entry__submit" type="submit" disabled={saving}>
                {saving ? 'Saving…' : 'Save job kinds'}
              </button>
            </div>
          </form>
        ) : null}
      </section>
    </main>
  );
}

async function extractError(response) {
  try {
    const payload = await response.json();
    return payload.message || payload.error?.message || `Request failed with status ${response.status}`;
  } catch {
    return `Request failed with status ${response.status}`;
  }
}
